/* assets/video-gallery-teleport.js (include it in theme.liquid or theme.js) */
document.addEventListener('DOMContentLoaded', () => {
  // Section container that Shopify rendered near the bottom of the page
  const gallery = document.querySelector('[data-video-gallery]');
  // Placeholder inside main-product > video_gallery block
  const target  = document.getElementById('video-gallery-placeholder');
  console.log("GALLERY = " + gallery);
  console.log("target = " + target);

  if (gallery && target) {
    target.appendChild(gallery);     // 🚚 move the node
    target.classList.add('loaded');  // optional styling hook
  }
});
